// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group-style .form-button[data-v-e074f11c]{padding-left:0}", ""]);
// Exports
module.exports = exports;
